"use strict";

(() => {
  // Initialize Lenis
  window.lenis = new Lenis({
    duration: 1.2,
    smooth: true,
    smoothTouch: true
  });

  function raf(time) {
    window.lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  window.currentScroll = 0;

  let viewportHeight = window.innerHeight;
  const activeParallaxElements = new Set();
  const activeLines = new Set();
  let ticking = false;

  const updateViewport = () => viewportHeight = window.innerHeight;
  window.addEventListener("resize", updateViewport);
  window.addEventListener("orientationchange", updateViewport);

  /* ---------------------------------------
   * Parallax elements
   * ------------------------------------- */
  const parallaxData = (el) => {
    if (el._parallaxData) return;
    const rect = el.getBoundingClientRect();
    const [start, end] = el.dataset.parallax.split(",").map(v => (Number(v) / 1000) * viewportHeight);
    el._parallaxData = {
      start, end,
      type: el.dataset.parallaxType || "vertical",
      elementTop: rect.top + window.currentScroll,
      unitScroll: (end - start) / (viewportHeight + rect.height)
    };
  };

  const parallaxObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const el = entry.target;
      if (entry.isIntersecting) {
        parallaxData(el);
        activeParallaxElements.add(el);
      } else {
        activeParallaxElements.delete(el);
        delete el._parallaxData;
      }
    });
  }, { threshold: 0 });

  const parallaxRO = new ResizeObserver(entries => entries.forEach(e => parallaxData(e.target)));
  document.querySelectorAll("[data-parallax]").forEach(el => {
    parallaxObserver.observe(el);
    parallaxRO.observe(el);
  });

  /* ---------------------------------------
   * Line animations
   * ------------------------------------- */
  const lineData = (line) => {
    if (line._parallaxData) return;
    const rect = line.getBoundingClientRect();
    line._parallaxData = {
      startScroll: rect.top + window.currentScroll - viewportHeight * 0.8,
      maxHeight: line.offsetHeight
    };
  };

  const lineObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const line = entry.target;
      if (entry.isIntersecting) {
        lineData(line);
        activeLines.add(line);
      } else {
        activeLines.delete(line);
        delete line._parallaxData;
      }
    });
  }, { threshold: 0 });

  const lineRO = new ResizeObserver(entries => entries.forEach(e => lineData(e.target)));
  document.querySelectorAll(".line-parallax").forEach(line => {
    lineObserver.observe(line);
    lineRO.observe(line);
  });

  /* ---------------------------------------
   * Scroll updates
   * ------------------------------------- */
  const handleScroll = () => {
    if (ticking) return;
    requestAnimationFrame(() => {
      activeParallaxElements.forEach(el => {
        const d = el._parallaxData;
        const rel = window.currentScroll + viewportHeight - d.elementTop;
        const value = d.unitScroll * rel + d.start;
        switch (d.type) {
          case "horizontal": el.style.transform = `translate3d(${value}px,0,0)`; break;
          case "rotate": el.style.transform = `rotate(${value}deg)`; break;
          case "scale": el.style.transform = `scale(${1 + value / 100})`; break;
          case "opacity": el.style.opacity = 1 + value / 100; break;
          default: el.style.transform = `translate3d(0,${value}px,0)`; break;
        }
      });

      activeLines.forEach(line => {
        const d = line._parallaxData;
        const progress = Math.min(Math.max(window.currentScroll - d.startScroll, 0) / d.maxHeight, 1);
        line.style.transform = `scaleY(${progress})`;
      });
      ticking = false;
    });
    ticking = true;
  };

  window.lenis.on("scroll", ({ scroll }) => {
    window.currentScroll = scroll;
    handleScroll();
  });

  requestAnimationFrame(() => handleScroll());

  /* ---------------------------------------
   * Element visibility animation
   * ------------------------------------- */
  const animateObserver = new IntersectionObserver(entries => {
    entries.forEach(e => e.target.classList.toggle("visible", e.intersectionRatio > 0.9));
  }, { threshold: [0.9] });
  document.querySelectorAll(".animate").forEach(el => animateObserver.observe(el));

  /* ---------------------------------------
   * Dispatch ready event for main.js
   * ------------------------------------- */
  window.dispatchEvent(new CustomEvent("lenisReady", { detail: { lenis: window.lenis } }));
})();
